import { SELECTED_COMPANY } from '~/common/constants';
export const SET_SELECTED_COMPANY = `${SELECTED_COMPANY}_SET`;

export const setCompany = (id) => ({ type: SET_SELECTED_COMPANY, id });
